module.exports = __webpack_public_path__ + "static/media/main5.ab1407ca.jpeg";